export const getCurrencySymbol = (currencyCode) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
    });

    const parts = formatter.formatToParts(1);
    return parts.find(part => part.type === 'currency').value;
}